module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c(_vm.componentType || 'button', {
    tag: "component",
    staticClass: "glossy-button",
    class: [_vm.color]
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4b178b7a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/GlossyButton.vue
// module id = 43
// module chunks = 0